const addressTypeList = [
  { value: 0, label: "Alameda", ENUM: "ALAMEDA" },
  { value: 1, label: "Avenida", ENUM: "AVENIDA" },
  { value: 2, label: "Chácara", ENUM: "CHACARA" },
  { value: 3, label: "Colônia", ENUM: "COLONIA" },
  { value: 4, label: "Condomínio", ENUM: "CONDOMINO" },
  { value: 5, label: "Eqnp", ENUM: "EQNP" },
  { value: 6, label: "Estância", ENUM: "ESTANCIA" },
  { value: 7, label: "Estrada", ENUM: "ESTRADA" },
  { value: 8, label: "Fazenda", ENUM: "FAZENDA" },
  { value: 9, label: "Praça", ENUM: "PRACA" },
  { value: 10, label: "Prolongamento", ENUM: "PROLONGAMENTO" },
  { value: 11, label: "Rodovia", ENUM: "RODOVIA" },
  { value: 12, label: "Rua", ENUM: "RUA" },
  { value: 13, label: "Sítio", ENUM: "SITIO" },
  { value: 14, label: "Travessa", ENUM: "TAVESSA" },
  { value: 15, label: "Vicinal", ENUM: "VICINAL" },
];

export default addressTypeList;
